import React from 'react';
import probies from '../../assets/probiesFooter.png';
import ilegra from '../../assets/logo-ilegra.png';
import arrow from '../../assets/arrowToTop.svg';
import './Footer.css';

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0
    });
  };
  
  return (
    <footer>
      <div className="footer-content">
        <div className="text-footer">
          <img src={probies} className="probies-img" alt='Probies é uma marca Ilegra' />
          <img src={ilegra} className="ilegra-logo-img" alt='Logo Ilegra' />
        </div>
        <button className="scrollToTopButton" onClick={scrollToTop}>
          <img src={arrow} className="arrow-white" alt="Seta para cima" />
        </button>
      </div>
    </footer>
  );
}
export default Footer;